import {
  bool,
  shape,
  exact,
  string,
  number,
  arrayOf,
  any,
  element,
  oneOfType,
  oneOf,
  func,
} from 'prop-types';

export const apiStatus = shape({
  ok: bool,
  loading: bool,
  error: bool,
  message: string,
});

export const missionEntity = exact({
  id: string,
  displayName: string,
  indexes: arrayOf(string),
});

export const missionEntities = arrayOf(missionEntity);

export const selectItems = arrayOf(
  exact({
    caption: oneOfType([string, number, element]),
    value: any,
  }),
);

export const updateStats = exact({
  nbTagsProcessed: number,
  nbTagsChecked: number,
  nbTagsToUpdate: number,
  nbTagsUpdated: number,
});

export const query = shape({
  status: oneOf(['success', 'loading', 'error', 'idle']),
  isLoading: bool,
  isSuccess: bool,
  isError: bool,
  isIdle: bool,
  // eslint-disable-next-line react/forbid-prop-types
  data: any,
  mutate: func,
  failureCount: number,
  isFetched: bool,
  isFetchedAfterMount: bool,
  isFetching: bool,
  isFetchingMore: bool,
  isInitialData: bool,
  isPreviousData: bool,
  isStale: bool,
  updatedAt: number,
});

export default {
  apiStatus,
  missionEntity,
  missionEntities,
  query,
  selectItems,
  updateStats,
};
